const buildBrandLogoUrl = (brand: string, common = true) => {
  const domain = common ? 'https://common.very.co.uk' : 'https://www.very.co.uk';
  const path = 'assets/static';

  return `${domain}/${path}/${brand}.svg`;
};

interface BrandLogoImageMapInterface {
  [key: string]: string;
}

const brandLogoImageMap: BrandLogoImageMapInterface = {
  'ann summers': buildBrandLogoUrl('ann-summers'),
  berghaus: buildBrandLogoUrl('berghaus'),
  hype: buildBrandLogoUrl('F993'),
  kickers: buildBrandLogoUrl('kickers'),
  lacoste: buildBrandLogoUrl('lacoste'),
  'pour moi': buildBrandLogoUrl('pourmoi', false),
  quiz: buildBrandLogoUrl('quiz'),
  reebok: buildBrandLogoUrl('reebok'),
  speedo: buildBrandLogoUrl('speedo'),
  adidas: buildBrandLogoUrl('adidas'),
  'adidas originals': buildBrandLogoUrl('adidas'),
  'adidas sportswear': buildBrandLogoUrl('adidas'),
  decathlon: buildBrandLogoUrl('decathlon'),
};

const getBrandLogoUrl = (brand: string) => brandLogoImageMap[`${brand.toLowerCase()}`];

export default getBrandLogoUrl;
